import React from 'react';
import { mdiDownload } from '@mdi/js';
import Icon from '@mdi/react';
import { Document, Page, pdfjs } from "react-pdf/dist/entry.webpack";
import "react-pdf/dist/Page/AnnotationLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class SessionHandouts extends React.Component {
    constructor(props) {
        super(props);
       //console.log(props);
        this.state = {
            code: global.$code,
            s3: global.$s3,
            bucket: global.$s3bucket,
            numPages: null,
            pageNumber: 1,
            file1: this.props.session.FILE1,
            file2: this.props.session.FILE2,
            file3: this.props.session.FILE3
        };
        if(this.state.file1 == "" || this.state.file1 == " ")
        {
            this.state.file1 = "empty"
        } 
        if(this.state.file2 == "" || this.state.file2 == " ")
        {
            this.state.file2 = "empty"
        }
        if(this.state.file3 == "" || this.state.file3 == " ")
        {
            this.state.file3 = "empty"
        }
    }

    render() {
        return (
            <div className="handouts">
                {
                    this.state.file1.includes("empty") ?
                        ('')
                        :
                        (
                            <div className="handout-div">
                                <a href={"https://event360live.s3.amazonaws.com/public/" + global.$code + "/schedule/" + this.state.file1} target="_blank">
                                    {
                                        this.state.file1.includes(".pdf")?
                                        (
                                            <Document
                                                file={"https://event360live.s3.amazonaws.com/public/" + global.$code + "/schedule/" + this.state.file1}
                                                onLoadSuccess={this.onDocumentLoadSuccess}
                                                className="pdf-thumbnail"
                                                loading="Loading..."
                                            >
                                                <Page pageNumber={this.state.pageNumber} width={150} />
                                            </Document>
                                        )
                                        :
                                        (
                                            ''
                                        )
                                    }
                                    <Icon path={mdiDownload} size={0.9} />Download
                                                </a>
                                <br />
                            </div>
                        )
                }
                {
                    this.state.file2.includes("empty") ?
                        ('')
                        :
                        (
                            <div className="handout-div">
                                <a href={"https://event360live.s3.amazonaws.com/public/" + global.$code + "/schedule/" + this.state.file2} target="_blank">
                                    {
                                        this.state.file2.includes(".pdf")?
                                        (
                                            <Document
                                                file={"https://event360live.s3.amazonaws.com/public/" + global.$code + "/schedule/" + this.state.file2}
                                                onLoadSuccess={this.onDocumentLoadSuccess}
                                                className="pdf-thumbnail"
                                                loading="Loading..."
                                            >
                                                <Page pageNumber={this.state.pageNumber} width={150} />
                                            </Document>
                                        )
                                        :
                                        (
                                            ''
                                        )
                                    }
                                    <Icon path={mdiDownload} size={0.9} />Download
                                                </a>
                                <br />
                            </div>
                        )
                }
                {
                    this.state.file3.includes("empty") ?
                        ('')
                        :
                        (
                            <div className="handout-div">
                                <a href={"https://event360live.s3.amazonaws.com/public/" + global.$code + "/schedule/" + this.state.file3} target="_blank">
                                    {
                                        this.state.file1.includes(".pdf")?
                                        (
                                            <Document
                                                file={"https://event360live.s3.amazonaws.com/public/" + global.$code + "/schedule/" + this.state.file3}
                                                onLoadSuccess={this.onDocumentLoadSuccess}
                                                className="pdf-thumbnail"
                                                loading="Loading..."
                                            >
                                                <Page pageNumber={this.state.pageNumber} width={150} />
                                            </Document>
                                        )
                                        :
                                        (
                                            ''
                                        )
                                    }
                                    <Icon path={mdiDownload} size={0.9} />Download
                                                </a>
                                <br />
                            </div>
                        )
                }

            </div>
        )
    }

}
export default SessionHandouts;


